var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.212 14.659a.914.914 0 01-1.423 0c-3.082-3.945-4.622-6.794-4.622-8.546C3.167 3.289 5.555 1 8.5 1c2.946 0 5.333 2.29 5.333 5.113 0 1.752-1.54 4.601-4.621 8.546zM8.5 8.669c1.473 0 2.667-1.145 2.667-2.557 0-1.411-1.194-2.556-2.667-2.556-1.473 0-2.667 1.145-2.667 2.556 0 1.412 1.194 2.557 2.667 2.557z",
    fill: "#D4D5D6"
  })));
}
export default SvgLarge;